export const reminderTypes = [
  {
    id: '1',
    name: 'Vet Appointment',
    imageName: 'Appointment.jpg',
  },
  {
    id: '2',
    name: 'Vaccination',
    imageName: 'Vaccination.jpg',
  },
  {
    id: '3',
    name: 'Deworming',
    imageName: 'Deworming.jpg',
  },
  {
    id: '4',
    name: 'Medicine',
    imageName: 'Medicine.jpg',
  },
  {
    id: '5',
    name: 'Defleaing',
    imageName: 'Defleaing.jpg',
  },
  {
    id: '6',
    name: 'Bath & Grooming',
    imageName: 'Grooming.jpg',
  },
  {
    id: '9',
    name: 'Heat Cycle',
    imageName: 'Heat.jpg',
  },
  {
    id: '7',
    name: 'Other',
    imageName: 'Other.jpg',
  },
  {
    id: '8',
    name: 'Birthday',
    imageName: 'Other.png',
  },
];
